<template>
  <div>
    <!-- Cadastro Status -->
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/1 w-full">
        <vx-card>
          <div class="mt-5">
            <vs-tabs alignment="fixed" v-model="passo">
              <!-- Status de Associados -->
              <vs-tab label="Status de Beneficiário">
                <div>
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/2 w-full">
                      <FormStatus :tipo="'ASSOCIADOS'" @add="atualizaLista" />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                      <table class="table table-bordered">
                        <tr>
                          <th class="uppercase text-center">Id</th>
                          <th class="uppercase">Status</th>
                          <th class="uppercase"></th>
                        </tr>
                        <tr
                          v-for="item in filtraArray('ASSOCIADOS')"
                          :key="item.id"
                        >
                          <td class="text-center">{{ item.idStatus }}</td>
                          <td>{{ item.nomeStatus }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </vs-tab>

              <!-- Status de Veículos -->
              <vs-tab label="Status de Veículos">
                <div>
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/2 w-full">
                      <FormStatus :tipo="'VEÍCULOS'" @add="atualizaLista" />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                      <table class="table table-bordered">
                        <tr>
                          <th class="uppercase text-center">Id</th>
                          <th class="uppercase">Status</th>
                          <th class="uppercase"></th>
                        </tr>
                        <tr
                          v-for="item in filtraArray('VEÍCULOS')"
                          :key="item.id"
                        >
                          <td class="text-center">{{ item.idStatus }}</td>
                          <td>{{ item.nomeStatus }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </vs-tab>
            </vs-tabs>
          </div>
        </vx-card>
      </div>
    </div>

    <!-- Máquina de Status -->
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/1 w-full">
        <vx-card>
          <h3>Máquina de Status</h3>
          <div>
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <div class="my-8 flex flex-row-reverse">
                  <vs-button
                    color="primary"
                    type="filled"
                    @click="openModalCreate()"
                  >
                    Adicionar Nova Regra
                  </vs-button>
                </div>

                <table class="table table-bordered">
                  <tr>
                    <th class="uppercase" style="width: 20%">
                      Tipo de Alteração
                    </th>
                    <th class="uppercase" style="width: 20%">Variaveis</th>
                    <th class="uppercase" style="width: 25%">
                      Status Beneficiário
                    </th>
                    <th class="uppercase" style="width: 25%">Status Veículo</th>
                    <th class="uppercase" style="width: 10%">Ações</th>
                  </tr>
                  <tr v-for="item in maquinaStatus" :key="item.id">
                    <td class="p-2">
                      {{ item.descricao_variacao }}
                      <span v-if="item.dependeAprovacao" class="chip mt-2">
                        Depende de Aprovação
                      </span>
                    </td>
                    <td class="p-2">{{ item.variaveis }}</td>
                    <td>
                      <div class="p-2">
                        <div v-if="item.statusAssociadoAnterior">
                          <span class="chip mb-1">Status Atual</span>
                          <span>{{ item.statusAssociadoAnterior }}</span>
                        </div>

                        <div
                          v-if="item.statusAssociadoAnterior"
                          class="mx-2 my-2"
                        >
                          <vs-icon
                            class="medium"
                            icon-pack="feather"
                            icon="icon-arrow-down"
                          ></vs-icon>
                        </div>

                        <div v-if="item.status_associado">
                          <span class="chip chip-success mb-1">
                            Novo Status
                          </span>
                          <span>{{ item.status_associado }}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="p-2">
                        <div v-if="item.statusVeiculoAnterior">
                          <span class="chip mb-1">Status Atual</span>
                          <span>{{ item.statusVeiculoAnterior }}</span>
                        </div>

                        <div
                          v-if="item.statusVeiculoAnterior"
                          class="mx-2 my-2"
                        >
                          <vs-icon
                            class="medium"
                            icon-pack="feather"
                            icon="icon-arrow-down"
                          ></vs-icon>
                        </div>

                        <div v-if="item.status_veiculo">
                          <span class="chip chip-success mb-1">
                            Novo Status
                          </span>
                          <span>{{ item.status_veiculo }}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <vs-button
                        v-tooltip="'Editar'"
                        radius
                        color="primary"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-edit"
                        class="d-inline lg:mx-1 float-left"
                        @click="opemModalUpdate(item)"
                      ></vs-button>
                      <vs-button
                        v-tooltip="'Deletar'"
                        radius
                        color="danger"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-minus"
                        class="d-inline lg:mx-1 float-left"
                        @click="openModalDelete(item.id_variacao_empresa)"
                      ></vs-button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <!-- Modal Exclusão -->
    <vs-popup
      :title="'Excluir Regra'"
      :active.sync="popDeleteMaquina"
      @close="popDeleteMaquina = false"
    >
      Tem certeza que deseja excluir a regra?<br />
      <vs-button @click="deleteMaquina()" color="danger" class="mb-2 my-5 ml-2">
        <span>Sim</span>
      </vs-button>
      <vs-button color="success" @click="popDeleteMaquina = false" class="ml-2">
        Não
      </vs-button>
    </vs-popup>

    <!-- Modal Adição/Exclusão  -->
    <vs-popup
      :title="objUpdate ? 'Atualizar Regra' : 'Adicionar Regra'"
      :active.sync="popUpdate"
      @close="popUpdate = false"
    >
      <FormMaquinaStatus
        :listaStatusAssociados="filtraArray('ASSOCIADOS')"
        :listaStatusVeiculos="filtraArray('VEÍCULOS')"
        :maquinaStatusVariacoes="maquinaStatusVariacoes"
        :objUpdate="objUpdate"
        @add="buscaDadosMaquina()"
      />
    </vs-popup>
  </div>
</template>

<script>
import service from './../../../../services';
import notify from './../../../../utils/notify';

import FormStatus from './FormStatus.vue';
import FormMaquinaStatus from './FormMaquinaStatus.vue';

import { translateDictionary } from './dictonary';
import { decryptData } from './../../../../services/decryptData';

export default {
  components: {
    FormStatus,
    FormMaquinaStatus,
  },
  data() {
    return {
      status: [],
      maquinaStatus: [],
      maquinaStatusVariacoes: [],
      objUpdate: null,
      idDelete: null,
      popDeleteMaquina: false,
      popUpdate: false,
      passo: 0,
    };
  },
  methods: {
    openModalCreate() {
      this.objUpdate = null;
      this.popUpdate = true;
    },
    opemModalUpdate(obj) {
      this.popUpdate = true;
      this.objUpdate = obj;
    },
    openModalDelete(id) {
      this.popDeleteMaquina = true;
      this.idDelete = id;
    },
    atualizaLista(obj) {
      this.status.push(obj);
    },
    filtraArray(tipo) {
      var arr = this.status.filter((x) => x.tipoStatus == tipo);
      return arr;
    },
    deleteMaquina() {
      this.$vs.loading();
      var objSend = {};
      objSend.idVariacaoEmpresa = this.idDelete;
      service
        .post('status', 'deleteMaquinaStatus', objSend)
        .then(() => {
          this.popDeleteMaquina = false;
          this.idDelete = null;
          this.buscaDadosMaquina();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    buscaDados() {
      this.$vs.loading();
      var objSend = {};
      objSend.idEmpresa = this.idEmpresa;
      objSend.notDeleted = true;
      service
        .post('status', 'list', objSend)
        .then((res) => {
          if (res.data.length > 0) {
            this.status = res.data;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    buscaDadosMaquina() {
      this.popUpdate = false;
      this.objUpdate = null;
      this.$vs.loading();

      service
        .getAll('status', null, 'listMaquinaStatus')
        .then((res) => {
          if (res.data.length > 0) {
            this.maquinaStatus = [];

            res.data.forEach((element) => {
              const jsonFacilitador = JSON.parse(element.jsonFacilitador);
              const variaveis = translateDictionary(jsonFacilitador);

              element.variaveis = variaveis;
              this.maquinaStatus.push(element);
            });
          }

          this.$forceUpdate();
        })
        .catch((e) => {
          notify.notifyFail(this.$vs, e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
  },
  mounted() {
    this.buscaDados();
    this.buscaDadosMaquina();

    this.buscaDadosSelects(
      'domMaquinaStatusVariacoesStatus',
      'maquinaStatusVariacoes',
      'descricaoVariacao',
      'idVariacao',
    );
  },
};
</script>

<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 2px;

    span {
      display: block;
    }
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.chip {
  background: rgb(7, 143, 207);
  color: rgba(255, 255, 255, 0.9);
  border-radius: 0.25rem !important;
  padding: 2px 4px;
  font-weight: 700;
  display: inline-block !important;
}

.chip-success {
  background: rgba(var(--vs-success), 1);
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.forceWhite:hover {
  color: #fff !important;
}
</style>
